<template>
  <div>
    <v-table
      url="/api/v1/blacklistModerator"
      :attributes="[
        {
          attribute: 'word',
          name: 'Wort',
          type: 'InputCell',
          url: 'update_url'
        },
        {
          attribute: 'created_by.name',
          name: 'Erstellt von'
        },
        {
          attribute: 'created_at',
          name: 'Erstellt um',
          type: 'DateTimeCell'
        },
        {
          attribute: 'updated_by.name',
          name: 'Updated von'
        },
        {
          attribute: 'updated_at',
          name: 'Updated um',
          type: 'DateTimeCell'
        },
        {
          notification: 'Das Wort wurde aus dem Wörterbuch gelöscht',
          name: 'Entfernen',
          type: 'DeleteCell',
          label: 'Löschen',
          sortable: false
        }
      ]"
    >
      <div slot="title">
        <h4>Wörter bearbeiten</h4>
      </div>
    </v-table>
    <resource
      resource="blacklistModerator"
      resourceName="Blacklist"
      :attributes="attributes"
      @resource-persisted="$bus.$emit('refresh-table')"
    >
      <div slot="title">
        <h4>Wörter hinzufügen</h4>
      </div>
    </resource>
    <v-table
      name="BlacklistMessages"
      url="/api/v1/blacklistMessage"
      :attributes="[
        {
          attribute: 'id',
          name: 'ID'
        },
        {
          name: 'Moderator',
          attribute: 'moderator_id',
          type: 'UserCell',
          sortable: false
        },
        {
          name: 'User',
          attribute: 'customer_id.name',
          sortable: false
        },
        {
          name: 'Fake',
          attribute: 'fake_profile_id.name',
          sortable: false
        },
        {
          name: 'Nachricht',
          attribute: 'message',
          type: 'SupportShortendMessageCell'
        },
        {
          name: 'Eingegangen',
          attribute: 'created_at',
          type: 'DateTimeCell'
        },
        {
          name: 'Moderator gesperrt',
          attribute: 'blocked',
          type: 'ToggleCell',
          url: 'block_toggle_url'
        },
        {
          name: 'Status',
          attribute: 'read',
          type: 'ToggleCell',
          url: 'read_toggle_url'
        },
        {
          name: 'Bearbeitung',
          type: 'SupportReadByCell'
        }
      ]"
    ></v-table>
  </div>
</template>

<script lang="babel">
export default {
  computed: {
    attributes() {
      return [
        {
          name: 'words',
          type: 'MultiInputSelector'
        }
      ];
    }
  }
};
</script>
